import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import '../../../../styles/scss/style.css';

//Components
import TextParagraph from '../../atoms/TextParagraph';
import Icon from '../../atoms/Icon';
import Button from '../../atoms/Button';
import { ROOT_URL } from '../../../config/global.js';
import { strings } from './ItemBlockContent';

//Returning the component
class ItemBlock extends Component {
	constructor(props) {
        super(props);

        this.state = {
			linkingBot: false,
			page: this.props.pageData,
			buttonText: this.props.pageData.subscriptions.length > 0 ? strings.buttonState.unlink : strings.buttonState.link,
			classTypeWrapper: this.props.pageData.subscriptions.length > 0 ? 'itemBlock--active' : ''
        }

		this.subscriptionHandler = this.subscriptionHandler.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		// Updating the component state when the store changes
		this.setState({ page: nextProps.pageData });
	}
	subscriptionHandler(e) {
		e.preventDefault();
		const lBotId = this.props.match.params.id; // Taking the botId from the URL.
		this.setState({ 
			linkingBot: true,
			buttonText: strings.buttonState.loading,
			classTypeWrapper: 'itemBlock--loading'
		});
		let theMethod = 'post';
		let theUrl = `${ROOT_URL}/api/subscriptions`;
		let theData = {
			pageId: this.state.page._id,
			botId: lBotId,
			plan: 'Basic'
		};	
		if (this.state.page.subscriptions.length > 0) {
			theMethod = 'delete';
			theUrl = `${ROOT_URL}/api/subscriptions/${this.state.page.subscriptions[0]._id}`;
			theData = {};
		}

		const theRequest = axios({
            method: theMethod,
            url: theUrl,
            data: theData
		});
		
		theRequest.then( (res) => {
			if (this.state.page.subscriptions.length > 0) {
				this.setState({
					linkingBot: false,
					buttonText: strings.buttonState.link,
					classTypeWrapper: '',
					facebookRes: res.data
				});
			} else {
				this.setState({
					linkingBot: false,
					buttonText: strings.buttonState.unlink,
					classTypeWrapper: 'itemBlock--active',
					facebookRes: res.data
				});
			}
			// Updating the store again
			this.props.setPages(res.data);
        });
	}
	render() {
		return (
			<div className={`itemBlock ${this.state.classTypeWrapper}`}>
			<div className="itemBlock__text">
			<Icon classType={this.props.classTypeIcon} />
				<TextParagraph classType="itemBlock__heading" text={this.state.page.name} />
				</div>
				<Button classType={this.props.classTypeButton} onClick={(e) => this.subscriptionHandler(e)} text={this.state.buttonText} iconRight={this.props.iconRight} />
			</div>
		)
	}
}

//Making sure that it has a text property when it's declared
ItemBlock.propTypes = {
	classTypeWrapper: PropTypes.string,
	classTypeIcon: PropTypes.string,
	classTypeButton: PropTypes.string,
	buttonText: PropTypes.string,
	iconRight: PropTypes.string
}

export default withRouter(ItemBlock);


// WEBPACK FOOTER //
// ./src/redux/components/molecules/ItemBlock/ItemBlock.jsx